import React, { useState } from "react";
import { ROOM_ENCOUNTERS } from "./data.js";

const TAG_STYLE = {
  good: "border-lime bg-lime/10 text-lime",
  weak: "border-gold bg-gold/10 text-gold",
  bad: "border-danger bg-danger/10 text-danger",
};

export default function RoomStage({ onComplete }) {
  const [index, setIndex] = useState(0);
  const [resolved, setResolved] = useState(null);
  const [log, setLog] = useState([]);

  const encounter = ROOM_ENCOUNTERS[index];
  const done = index >= ROOM_ENCOUNTERS.length;

  const choose = (choice) => {
    setResolved(choice);
    setLog((prev) => [...prev, { title: encounter.title, choice }]);
  };

  const advance = () => {
    const isLast = index + 1 >= ROOM_ENCOUNTERS.length;
    if (isLast) {
      onComplete({ log });
      return;
    }
    setResolved(null);
    setIndex((i) => i + 1);
  };

  if (done) return null;

  return (
    <div>
      <div className="mb-4 flex items-center justify-between font-display text-[9px] text-mist/50">
        <span>THE ROOM</span>
        <span>
          {index + 1}/{ROOM_ENCOUNTERS.length}
        </span>
      </div>

      <div className="animate-popIn mb-5 border-2 border-black bg-ink p-5">
        <p className="pixel-heading mb-3 text-sm text-mist">{encounter.title}</p>
        <p className="text-sm leading-relaxed text-mist/80">{encounter.text}</p>
      </div>

      {!resolved ? (
        <div className="space-y-2">
          {encounter.choices.map((choice) => (
            <button
              key={choice.id}
              onClick={() => choose(choice)}
              className="w-full border-2 border-mist/30 px-4 py-3 text-left text-xs text-mist transition-colors hover:border-cyan hover:text-cyan"
            >
              {choice.label}
            </button>
          ))}
        </div>
      ) : (
        <div className={`animate-popIn border-2 p-4 text-center ${TAG_STYLE[resolved.tag]}`}>
          <p className="mb-3 text-xs">{resolved.result}</p>
          <button onClick={advance} className="btn-cyan !text-[9px]">
            CONTINUE ▶
          </button>
        </div>
      )}
    </div>
  );
}
